import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { FAQS } from "@/config";

export default function Faq() {
    return (
        <section id="faq" data-testid="faq" className="scroll-mt-24 bg-white py-20 sm:py-28">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="FAQ" title="Domande frequenti" />

                <Reveal delay={0.15} className="mt-12">
                    <Accordion
                        type="single"
                        collapsible
                        data-testid="faq-accordion"
                        className="w-full rounded-3xl border border-ink/5 bg-paper px-6 shadow-[0_12px_35px_-15px_rgba(11,18,32,0.08)] sm:px-8"
                    >
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="border-b border-ink/5 last:border-0"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-accordion-item-${i}`}
                                    className="py-5 text-left font-display text-base font-semibold tracking-tight text-ink hover:no-underline sm:text-lg"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-slate-500">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
